import { z } from 'zod';
import {
  habitSchema,
  type CreateHabitRequest,
  type Habit,
  type UpdateHabitRequest,
} from '@mrrmlab/shared-types';
import type { HttpClient } from './http';

const habitListSchema = z.array(habitSchema);

export class HabitsResource {
  constructor(private readonly http: HttpClient) {}

  list(signal?: AbortSignal): Promise<Habit[]> {
    return this.http.request({
      method: 'GET',
      path: '/habits',
      responseSchema: habitListSchema,
      signal,
    });
  }

  create(body: CreateHabitRequest, signal?: AbortSignal): Promise<Habit> {
    return this.http.request({
      method: 'POST',
      path: '/habits',
      body,
      responseSchema: habitSchema,
      signal,
    });
  }

  update(id: string, body: UpdateHabitRequest, signal?: AbortSignal): Promise<Habit> {
    return this.http.request({
      method: 'PATCH',
      path: `/habits/${id}`,
      body,
      responseSchema: habitSchema,
      signal,
    });
  }

  delete(id: string, signal?: AbortSignal): Promise<void> {
    return this.http.request({
      method: 'DELETE',
      path: `/habits/${id}`,
      expectEmpty: true,
      signal,
    });
  }
}
